/* eslint-disable @next/next/no-img-element */
import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";
import Link from "next/link";
import React from "react";
import { CgPlayList } from "react-icons/cg";
import styles from "./vlog_playlist_card.module.scss";

export const VlogPlaylistCard = ({ item }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.image_wrapper}>
        <Image
          layout="responsive"
          width={270}
          height={200}
          blurDataURL={getAssets("assets/images/image_placeholder_big.webp")}
          placeholder="blur"
          className=""
          src={
            item?.featureImage?.src ||
            getAssets("assets/images/image_placeholder_big.webp")
          }
          alt={item?.title}
        />

        <Link legacyBehavior href={`/vlog/playlist/${item?.slug}`}>
          <a className={styles.list_detail}>
            <div className={styles.count}>{item?.videos}</div>
            <div className={styles.list_icon}>
              <CgPlayList />
            </div>
          </a>
        </Link>
      </div>

      <div className={styles.details_wrapper}>
        <Link legacyBehavior href={`/vlog/playlist/${item?.slug}`}>
          <a className={styles.title}>{item?.title}</a>
        </Link>
        <div className={styles.description}>{item?.summary}</div>
      </div>
    </div>
  );
};

export default VlogPlaylistCard;
